module.exports = __webpack_public_path__ + "img/category_cover_Children.db4eb7e.webp";